theme.footerSection = (function () {
  function footer() {
    const footerWidgetAccordion = function () {
      document.querySelectorAll(".footer__widget_toggle").forEach(function (item) {
        // Guard: don't attach a second listener to the same button
        if (item.dataset.listenerAdded === "true") return;
        item.dataset.listenerAdded = "true";

        item.addEventListener("click", function () {
          const footerWidget = this.closest(".footer__widget"),
            footerWidgetInner = footerWidget.querySelector(".footer__widget_inner");

          if (footerWidget.classList.contains("active")) {
            footerWidget.classList.remove("active");
            slideUp(footerWidgetInner);
          } else {
            footerWidget.classList.add("active");
            slideDown(footerWidgetInner);
            getSiblings(footerWidget.parentElement).forEach(function (sibling) {
              const siblingWidget = sibling.querySelector(".footer__widget"),
                siblingWidgetInner = sibling.querySelector(".footer__widget_inner");
              if (siblingWidget && siblingWidgetInner) {
                siblingWidget.classList.remove("active");
                slideUp(siblingWidgetInner);
              }
            });
          }
        });
      });
    };

    footerWidgetAccordion();

    window.addEventListener("resize", function () {
      document.querySelectorAll(".footer__widget").forEach(function (item) {
        if (window.outerWidth >= 768) {
          item.classList.remove("active");
          item.querySelector(".footer__widget_inner").style.display = "";
        }
      });
      footerWidgetAccordion();
    });
  }
  return footer;
})();